import { useEffect, RefObject } from 'react';

const usePlayVideoInPowerSaveMode = (videoRef: RefObject<HTMLVideoElement>): void => {
  // проигрывать видео на интеракт, на девайсах на которых включен режим энергосбережения
  useEffect(() => {
    const video = videoRef.current as HTMLVideoElement;

    const playVideo = () => {
      if (video && video.paused) {
        video.load();
        video.play();
      }
    };

    window.addEventListener('touchstart', playVideo);
    window.addEventListener('click', playVideo);

    return () => {
      window.removeEventListener('touchstart', playVideo);
      window.removeEventListener('click', playVideo);
    };
  }, []);
};

export default usePlayVideoInPowerSaveMode;
